export default "__VITE_ASSET__D9IYsqjW__"